import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const WizardButtons = ({
  step,
  currentIndex,
  lastIndex,
  previousHandler,
  nextHandler,
  completedHandler,
  cancelHandler,
  errorHandler,
  nextText,
  backBtnText,
  disabled,
}) => {
  const displayButton = () => {
    if (currentIndex !== 0 && step.preventBackButton) {
      return (
        <Button
          variant="outlined"
          onClick={() => {
            previousHandler();
          }}
          startIcon={<ArrowBackIosIcon />}
        >
          {backBtnText ? backBtnText : 'Back'}
        </Button>
      );
    }
    if (currentIndex !== lastIndex) {
      return (
        <Button
          variant="contained"
          disabled={isDisabled()}
          onClick={() => {
            nextHandler();
          }}
          endIcon={<ArrowForwardIosIcon />}
        >
          {nextText ? nextText : 'Next'}
        </Button>
      );
    }
    if (currentIndex === lastIndex) {
      return (
        <Button
          variant="contained"
          onClick={() => {
            completedHandler();
          }}
        >
          Finish
        </Button>
      );
    }
    if (cancelHandler) {
      return (
        <Button
          variant="contained"
          onClick={() => {
            cancelHandler();
          }}
        >
          Cancel
        </Button>
      );
    }
  };

  const isDisabled = () => {
    if (disabled) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="wizardButtons">
      <Stack direction="row" spacing={2}>
        {currentIndex !== 0 && step.preventBackButton && (
          <Button
            variant="outlined"
            onClick={() => {
              previousHandler();
            }}
            startIcon={<ArrowBackIosIcon />}
          >
            {backBtnText ? backBtnText : 'Back'}
          </Button>
        )}
        {currentIndex !== lastIndex && (
          <Button
            variant="contained"
            disabled={isDisabled()}
            onClick={() => {
              nextHandler();
            }}
            endIcon={<ArrowForwardIosIcon />}
          >
            {nextText ? nextText : 'Next'}
          </Button>
        )}
        {currentIndex === lastIndex && (
          <Button
            variant="contained"
            onClick={() => {
              completedHandler();
            }}
          >
            Finish
          </Button>
        )}
        {cancelHandler && (
          <Button
            variant="contained"
            onClick={() => {
              cancelHandler();
            }}
          >
            Cancel
          </Button>
        )}
      </Stack>
    </div>
  );
};

export { WizardButtons };
